import { render, staticRenderFns } from "./OfflineBanner.vue?vue&type=template&id=4205b994&scoped=true"
import script from "./OfflineBanner.vue?vue&type=script&lang=js"
export * from "./OfflineBanner.vue?vue&type=script&lang=js"
import style0 from "./OfflineBanner.vue?vue&type=style&index=0&id=4205b994&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4205b994",
  null
  
)

export default component.exports